module.exports = __webpack_public_path__ + "img/currys.3509dc6d.svg";